<template>
  <div>
    <div>Dashboard > STYLIST NAME > Manage CLients > Add Clients</div>
    Add Clients
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
</style>
